import { StandardEvents } from '@shopify/events';

class GetPaymentActions extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.addEventListener('click', (event) => this.purchase(event), { signal });
    this.section = this.closest('.shopify-section');
    this.section?.addEventListener(StandardEvents.productSelect, (event) => {
      if (event.target.closest('product-card')) return;
      const pending = event.promise;
      this.pending = pending;
      this.syncButtons();
      Promise.resolve(pending).catch(() => {}).finally(() => {
        if (this.pending === pending) {
          this.pending = null;
          this.syncButtons();
        }
      });
    }, { signal });
    this.observer?.disconnect();
    this.observer = new MutationObserver(() => this.syncButtons());
    const form = this.form;
    if (form) this.observer.observe(form, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'value'] });
    this.syncButtons();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
  }

  get form() {
    return this.closest('.buy-buttons-block')?.querySelector('product-form-component form');
  }

  syncButtons() {
    const form = this.form;
    const unavailable = !form || !form.querySelector('[name="id"]')?.value ||
      form.querySelector('[ref="addToCartButton"]')?.disabled;
    for (const button of this.querySelectorAll('[data-payment-destination]')) {
      const disabled = Boolean(this.busy || this.pending || unavailable);
      if (button.disabled !== disabled) button.disabled = disabled;
    }
  }

  async purchase(event) {
    const button = event.target.closest('[data-payment-destination]');
    if (!button || !this.contains(button) || button.disabled || this.busy || this.pending) return;
    event.preventDefault();
    const form = this.form;
    const status = this.querySelector('[role="status"]');
    if (!form || !form.reportValidity()) return;
    const original = form.querySelector('[ref="addToCartButton"]');
    if (!original || original.disabled) {
      status.textContent = this.dataset.unavailable;
      return;
    }
    const body = new FormData(form);
    if (!body.get('id')) return;
    const component = form.closest('product-form-component');
    const quantity = body.get('quantity') || component?.dataset.quantityDefault || '1';
    body.set('quantity', quantity);
    body.delete('sections');
    body.delete('sections_url');
    this.busy = true;
    this.syncButtons();
    this.setAttribute('aria-busy', 'true');
    status.textContent = this.dataset.loading;
    const originallyDisabled = original.disabled;
    original.disabled = true;
    try {
      const response = await fetch(this.dataset.addUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        body
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
      }
      const cartUrl = new URL(this.dataset.cartUrl, window.location.origin);
      if (button.dataset.paymentDestination === 'checkout') {
        cartUrl.pathname = cartUrl.pathname.replace(/\/$/, '') + '/checkout';
      }
      window.location.assign(cartUrl.href);
    } catch (error) {
      status.textContent = error instanceof Error && error.message ? error.message : this.dataset.error;
      this.busy = false;
      original.disabled = originallyDisabled;
      this.removeAttribute('aria-busy');
      this.syncButtons();
    }
  }
}
if (!customElements.get('get-payment-actions')) customElements.define('get-payment-actions', GetPaymentActions);
